import { useState } from 'react'
import './App.css'
import { GVVRComplete } from './components/GVVRComplete'
import { GVVRVoiceOrchestrationDemo } from './components/voice/GVVRVoiceOrchestrationDemo'

function App() {
  const [view, setView] = useState<'main' | 'orchestration'>('main')

  return (
    <div>
      {/* Navigation */}
      <div className="fixed top-4 right-4 z-50">
        <div className="bg-white rounded-lg shadow-lg p-2 flex space-x-2">
          <button
            onClick={() => setView('main')}
            className={`px-3 py-1 rounded text-sm font-medium ${
              view === 'main' 
                ? 'bg-blue-600 text-white' 
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            Main App
          </button>
          <button
            onClick={() => setView('orchestration')}
            className={`px-3 py-1 rounded text-sm font-medium ${
              view === 'orchestration' 
                ? 'bg-purple-600 text-white' 
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            🎤 Voice Demo
          </button>
        </div>
      </div>

      {/* Content */}
      {view === 'main' ? <GVVRComplete /> : <GVVRVoiceOrchestrationDemo />}
    </div>
  )
}

export default App
